// extracted by mini-css-extract-plugin
export default {"about_wrap":"About_about_wrap__M8nUN","about":"About_about__Qndav"};